import type { NextPage } from "next";
import { Main } from "src/views/Main";

const MainPage: NextPage = () => <Main />;

export default MainPage;
